function headerReducer(state = { isSidebarVisible: false, isSearchFormVisible: false, primarySubmenu: null }, action) {
  switch (action.type) {
    case "TOGGLE_SIDEBAR_MENU":
      return { ...state, isSidebarVisible: !state.isSidebarVisible };
    case "OPEN_SIDEBAR_MENU":
      return { ...state, isSidebarVisible: true };
    case "CLOSE_SIDEBAR_MENU":
      return { ...state, isSidebarVisible: false };
    case "TOGGLE_SEARCHFORM":
      return { ...state, isSearchFormVisible: !state.isSearchFormVisible };
    case "CLOSE_SEARCHFORM":
      return { ...state, isSearchFormVisible: false };
    case "OPEN_PRIMARY_SUBMENU":
      return { ...state, primarySubmenu: action.payload.menuId };
    case "CLOSE_PRIMARY_SUBMENU":
      return { ...state, primarySubmenu: null };
    case "CLOSE_ALL":
      return { ...state, isSidebarVisible: false, isSearchFormVisible: false, primarySubmenu: null };
    default:
      return state;
  }
}

function loginReducer(state = false, action) {
  switch (action.type) {
    case "OPEN_LOGIN_TEMPLATE":
      return true;
    case "CLOSE_LOGIN_TEMPLATE":
      return false;
    default:
      return state;
  }
}

function meteringIndicatorReducer(state = true, action) {
  switch (action.type) {
    case "SHOW_METERING_INDICATOR":
      return true;
    case "HIDE_METERING_INDICATOR":
      return false;
    default:
      return state;
  }
}

function amazonPollyReducer(state = { isOpen: false, storyData: {} }, action) {
  switch (action.type) {
    case "OPEN_AMAZON_POLLY":
      return { ...state, isOpen: true };
    case "CLOSE_AMAZON_POLLY":
      return { ...state, isOpen: false };
    case "UPDATE_AMAZON_POLLY_DATA":
      return { ...state, storyData: { ...action.payload.storyData } };
    default:
      return state;
  }
}

function memberSubscriptionsReducer(state = [], action) {
  switch (action.type) {
    case "MEMBER_SUBSCRIPTIONS_UPDATED":
      return [...action.subscriptions];
    default:
      return state;
  }
}

export const CUSTOM_REDUCERS = {
  header: headerReducer,
  isLoginOpen: loginReducer,
  showMeteringIndicator: meteringIndicatorReducer,
  amazonPolly: amazonPollyReducer,
  memberSubscriptions: memberSubscriptionsReducer
};
